import {
    GET_FIRMWARE_MANAGEMENT,
    GET_FIRMWARE_MANAGEMENT_SUCCESS,
    GET_FIRMWARE_MANAGEMENT_FAIL,
} from '../../constants/firmwareManagementConstants/managementConstants';

/**
 * Reducer function for managing firmware management list state.
 *
 * This reducer handles actions related to fetching firmware management data.
 * It updates the state based on the dispatched action type and payload.
 *
 * @param {object} state - Current state of the firmware management list.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */
export const firmwareManagementListReducer = (state = { firmwareManagementList: {} }, action) => {
    switch (action.type) {
        case GET_FIRMWARE_MANAGEMENT:
            return {
                loading: true,
            };
        case GET_FIRMWARE_MANAGEMENT_SUCCESS:
            return {
                loading: false,
                firmwareManagementList: action.payload,
            };
        case GET_FIRMWARE_MANAGEMENT_FAIL:
            return {
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};
